import i18n from "@/i18n";
import en1 from "./en.json";
import en2 from "./en2.json";
import en3 from "./en3.json";
import en4 from "./en4.json";

// Dictionnaire centralisé FR → EN (clé = texte source français). AR/WO : textes non traduits restent en français.
const EN = { ...en1, ...en2, ...en3, ...en4 };

export const T = (s) => {
  if (typeof s !== "string" || i18n.language !== "en") return s;
  return EN[s] ?? EN[s.trim()] ?? s;
};
